<mat-tab-group [selectedIndex]="0">
  <mat-tab *ngFor="let bundeslandName of bundeslaenderTabs"
           [label]="bundeslandName">
    <h3 class="page-heading">Pollenflug Deutschland</h3>
    <div *ngIf="getPollenflugForBundesland(bundeslandName); let pollenflug" class="container">
      <mat-card class="mat-elevation-z2 pollenflug-heading">
        <mat-card-header>
          <mat-card-subtitle>
            <div>Quelle: {{pollenflug.dataProvider}}</div>
            <div>Aktualisiert: {{pollenflug.eingangsdatum.toDate() | date : 'dd.MM.yyyy HH:mm'}}</div>
            <div>Übernommen: {{pollenflug.erstellungsdatum.toDate() | date : 'dd.MM.yyyy HH:mm'}}</div>
          </mat-card-subtitle>
        </mat-card-header>
      </mat-card>
      <app-pollenflug-region
        *ngFor="let region of pollenflug.regionen"
        [region]="region">
      </app-pollenflug-region>
    </div>
  </mat-tab>
</mat-tab-group>
